import { render, staticRenderFns } from "./TableComparativa.vue?vue&type=template&id=56856514&style=true&"
import script from "./TableComparativa.vue?vue&type=script&lang=js&"
export * from "./TableComparativa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports